export default [
  // {
  //   path: '/dianbo',
  //   name: 'index',
  //   component: () => import('@/views/dianbo/course'),
  //   redirect: '/dianbo/course',
  //   children: [
  //     // {
  //     //   path: 'page1',
  //     //   name: 'dianbo-page1',
  //     //   component: () => import('@/views/user/list'),
  //     //   meta: { title: '' }
  //     // },
  //   ]
  // },
  {
    path: '/dianbo/course/:cid',
    name: 'course',
    component: () => import('@/views/dianbo/course'),
    meta: {
      isFullPath:true,
      title: '课程详情'
    }
  },
  {
    path: '/dianbo/course/:cid/:name',
    name: 'course',
    component: () => import('@/views/dianbo/course'),
    meta: {
      title: '课程详情'
    }
  },
  {
    path: '/dianbo/lecturercard/:tid',
    name: 'lecturercard',
    component: () => import('@/views/dianbo/lecturercard'),
    meta: {
      title: '讲师名片'
    }
  },
  {
    path: '/dianbo/payconfirm',
    name: 'payconfirm',
    component: () => import('@/views/dianbo/payconfirm'),
    meta: {
      title: '支付确认'
    }
  },
  {
    path: '/dianbo/jumptopay',
    name: 'jumptopay',
    component: () => import('@/views/dianbo/jumptopay'),
    meta: {
      title: ''
    }
  },
  {
    path: '/dianbo/recharge',
    name: 'recharge',
    component: () => import('@/views/dianbo/recharge'),
    meta: {
      title: '车币充值'
    }
  },
  {
    path: '/dianbo/rechargeresult',
    name: 'rechargeresult',
    component: () => import('@/views/dianbo/rechargeResult'),
    meta: {
      title: '支付结果'
    }
  },
  {
    path: '/dianbo/steadpay',
    name: 'steadpay',
    component: () => import('@/views/dianbo/steadPay'),
    meta: {
      title: '支付订单'
    }
  },
  {
    path: '/dianbo/liveroom/:lesson_id',
    name: 'liveroom',
    component: () => import('@/views/dianbo/liveroom'),
    meta: {
      title: '直播间'
    }
  },
  {
    path: '/dianbo/backplay/:lesson_id',
    name: 'backplay',
    component: () => import('@/views/dianbo/backplay'),
    meta: {
      title: '回放'
    }
  },
  {
    path: '/dianbo/landingPage',
    name: 'landingPage',
    component: () => import('@/views/dianbo/landingPage'),
    meta: {
      title: '高考志愿课程'
    }
  },
  {
    path: '/dianbo/record',
    name: 'record',
    component: () => import('@/views/dianbo/record'),
    meta: {
      title: '购买记录'
    }
  }
]
